import { ServicePage } from "@/components/ServicePage";

const PayEquity = () => (
  <ServicePage
    testid="pay-equity-page"
    overline="Pay Equity Compliance"
    titleLines={["Fix it before", "the state does."]}
    image="/generated/pay-equity.png"
    startingAt="Starting at $2,500"
    intro="Oregon's Equal Pay Act reaches further than most employers realize. A defensible self-audit turns a hidden liability into a documented safe harbor, and I'll walk you through every step."
    defaultService="pay-equity"
    steps={[
      { t: "Scope & comparators", d: "We map your roles into comparator groups based on work of comparable character, not just job titles." },
      { t: "Gap analysis", d: "We surface pay disparities and separate the ones explained by bona fide factors from the ones that aren't." },
      { t: "Remediation & safe harbor", d: "We build a documented, good-faith correction plan that positions you for Oregon's safe harbor protections." },
    ]}
    proofPoints={[
      { stat: "ORS 652.220", label: "The Oregon statute at the center of every pay-equity claim, decoded in plain language." },
      { stat: "Safe harbor", label: "A good-faith analysis can cap compensatory and punitive damages exposure." },
      { stat: "27 years", label: "Of HR leadership behind every audit finding and recommendation." },
      { stat: "Comparable character", label: "The standard Oregon actually uses, wider than the federal Equal Pay Act." },
    ]}
    faqs={[
      { q: "How is Oregon different from federal pay equity law?", a: "Oregon looks at 'work of comparable character' across your whole organization, not identical titles. Comparator groups are usually broader than employers expect, which is where most risk hides." },
      { q: "What is the safe harbor?", a: "If you complete a good-faith equal-pay analysis and correct unlawful disparities within a reasonable time, Oregon law can limit your exposure to compensatory and punitive damages in a claim." },
      { q: "Do you offer exact pricing online?", a: "Engagements start at $2,500 and scale with headcount and complexity. We'll give you a precise quote on your discovery call." },
    ]}
  />
);

export default PayEquity;
